import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
  setItemNameTranslit,
} from '@/modules/Dictionary/__form/item';

export default class DictionaryBoardingForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'boarding';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)();
    setItemNameLat.bind(this)();
    setItemNameTranslit.bind(this)();
    setItemCode.bind(this)();
  }
}
